
import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { updateSheets } from 'store/schedule/schedulePageOperation';
import ResourceSidebar from 'pages/ScheduleV6/components/resources/ResourceSidebar';

const Resource = () => {
  const dispatch = useDispatch();
  const selectedDate = useSelector((state) => state.schedule.selectedDate);
  const filters = useSelector((state) => state.schedule.filters);

  useEffect(() => {
    dispatch(updateSheets());
  }, [selectedDate, filters, dispatch]);

  return <ResourceSidebar isAdminMobile />;
};

export default Resource;
